// src/data/featuresDept.js
export const FEATURES_DEPT = [
  {
    id: "gps",
    title: "Zentra GPS",
    blurb:
      "Gestión de flotas en tiempo real desde web y app móvil. controla y monitorea tus vehículos 24/7.",
    bullets: [
      {
        strong: "Monitoreo en tiempo real:",
        text:
          "posición, velocidad, historial y reproducción de rutas.",
      },
      {
        strong: "Alertas y geocercas:",
        text:
          "entradas/salidas, exceso de velocidad, batería y desconexión.",
      },
      {
        strong: "Corte remoto de motor:",
        text:
          "apagado seguro bajo autorización para casos específicos.",
      },
      {
        strong: "Reportes y estadísticas:",
        text:
          "kilometraje, tiempos detenidos, uso y mantenimientos.",
      },
    ],
    art: "blue",
  },
  {
    id: "sistemas",
    title: "Zentra Sistemas",
    blurb:
      "Desarrollamos sistemas web y websites de alto rendimiento a la medida de tu negocio.",
    bullets: [
      {
        strong: "Sistemas y APIs a medida:",
        text:
          "portales, paneles internos, ERPs/CRMs y microservicios.",
      },
      {
        strong: "Integraciones:",
        text:
          "pagos, facturación electrónica, webhooks y servicios de terceros.",
      },
      {
        strong: "UX/UI + performance:",
        text:
          "interfaces modernas, SEO técnico y tiempos de carga optimizados.",
      },
      {
        strong: "Operación continua:",
        text:
          "DevOps, CI/CD, observabilidad y soporte evolutivo.",
      },
    ],
    art: "black",
  },
];
